define.alias("shared/utils/formatters/tweet-from-dynamo", "calendar/utils/formatters/tweet-from-dynamo");